import { GridColDef } from "@mui/x-data-grid";
import { formatDate } from "../../../helpers/formatingFunctions";
import UnassignButton from "../../../components/Fleet/UnassignButton/UnassignButton";
import { Link } from "react-router-dom";

export const assignedTrucksTableColumns: GridColDef[] = [
  {
    field: "unitNumber",
    headerName: "Unit number",
    width: 200,
    renderCell: (params) => (
      <Link to={`/fleet/assets/truck/${params.row.truckId}`}>
        {params.value}
      </Link>
    ),
  },
  { field: "vin", headerName: "VIN", width: 200 },
  {
    field: "dateAssigned",
    headerName: "Date Assigned",
    width: 200,
    valueFormatter: (value: string) => {
      return value ? formatDate(value) : value;
    },
  },
  {
    field: "dateUnassigned",
    headerName: "Date Unassigned",
    width: 200,
    valueFormatter: (value: string) => {
      return value ? formatDate(value) : value;
    },
  },
  {
    field: "unassignTruck",
    headerName: "",
    width: 200,
    renderCell: (params) => {
      return params.row.dateUnassigned ? null : (
        <UnassignButton
          id={params.row.truckId}
          type="truck"
          truckId={params.row.truckId}
        />
      );
    },
  },
];
